import React, { useState } from "react";
import "./faq.css";
import Header from "../../components/header1/Header1";
import Footer from "../../components/footer/Footer";
import bannerImage from "../../elements/hero-banner-faqs-page.png";
import { FaPlus } from "react-icons/fa6";
import { RxCross1 } from "react-icons/rx";
const FAQ = () => {
  const [expanded, setExpanded] = useState(null);
  const [activeSection, setActiveSection] = useState("students");

  const toggleAccordion = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const faqs = {
    students: [
      {
        question: "What is AI-Amplified Software Engineering?",
        answer:
          "It is a specialized program that equips students with AI and software engineering skills through a curated curriculum, practical projects, and industry-recognized certifications.",
      },
      {
        question: "What is the core objective of the program?",
        answer:
          "The program aims to prepare students for AI-driven industries by integrating AI tools into software engineering practices.",
      },
      {
        question: "What are the key benefits of this program?",
        answer:
          "Gain hands-on experience, mentorship, industry-ready certifications, and an enhanced professional portfolio.",
      },
      {
        question: "Who is eligible for the program?",
        answer:
          "Students from partner institutions or those referred by Agivant Associates are eligible.",
      },
      {
        question: "How do I register for the program?",
        answer:
          "Students can register through the designated link. Only eligible students whose details have been shared by partner institutions or Agivant Associates can register.",
      },
      {
        question: "Is there a fee to enroll in the program?",
        answer:
          "No, Agivant does not charge any fee for students to enroll in this program.",
      },
      {
        question: "What is the curriculum of the program?",
        answer:
          "It includes courses on AI, programming languages, coding platforms, and projects aligned with industry standards.",
      },
      {
        question: "Are there any assessments during the program?",
        answer:
          "Yes, there are courses and certifications that students must clear independently to be eligible for successful completion of the program.",
      },
      {
        question: "Will I receive a certificate upon completion?",
        answer:
          "Yes, you will receive a certification upon successfully completing the program, including all required assessments.",
      },
      {
        question: "How does this program enhance job opportunities?",
        answer:
          "The program’s curriculum and certifications are tailored to meet industry demands, giving you a competitive edge in the job market.",
      },
      {
        question:
          "Will I have the chance to work full-time at Agivant after the program?",
        answer:
          "Completion of the program is not related in any manner to securing an employment opportunity at Agivant.",
      },
      {
        question:
          "Does Agivant have any tie-ups with the platforms or providers of the courses and certifications suggested in this program?",
        answer:
          "No, we do not have any tie-ups, financial or otherwise, with any learning platforms, coding platforms, or global certification provider agencies. The courses and certifications included in this program are suggested solely based on inputs from our industry experts, who have carefully analyzed their value in enhancing students' skills and career readiness. Agivant does not sponsor any platform or certification agency under this program in any manner.",
      },
    ],
    colleges: [
      {
        question: "What is the scope of collaboration with Agivant?",
        answer:
          "Partnering institutions’ students will gain access to this program, allowing them to certify themselves with advanced AI and software engineering skills.",
      },
      {
        question: "What are the benefits of partnering with Agivant?",
        answer:
          "Students enhance their employability in the IT industry, become AI-ready, and receive mentorship from industry leaders.",
      },
      {
        question: "How will the program be integrated into our curriculum?",
        answer:
          "Based on discussions with the institution's administration, certain elements of the program can be embedded into the curriculum as credits.",
      },
      {
        question: "What are the responsibilities of the partner institution?",
        answer:
          "Partner institutions are responsible for promoting the program, facilitating student registrations, and ensuring faculty mentorship in partnership with Agivant mentors.",
      },
      {
        question: "How will student performance be assessed?",
        answer:
          "Performance is evaluated through coursework, assessments, and project reviews.",
      },
      {
        question: "Who can I contact for further inquiries?",
        answer:
          "Reach out to the Agivant partnership support team at aiampdse@agivant.com.",
      },
      {
        question:
          "Does Agivant have any tie-ups with the platforms or providers of the courses and certifications suggested in this program?",
        answer:
          "No, we do not have any tie-ups, financial or otherwise, with any learning platforms, coding platforms, or global certification provider agencies. The courses and certifications included in this program are suggested solely based on inputs from our industry experts, who have carefully analyzed their value in enhancing students' skills and career readiness. Agivant does not sponsor any platform or certification agency under this program in any manner.",
      },
    ],
  };

  return (
    <div className="faq min-h-screen flex flex-col md:mx-20">
      <Header />

      <div className="relative w-full">
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full sm:h-[300px] h-auto object-fit"
        />
        <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
          <div className="flex flex-col w-full sm:w-2/5 p-3">
            {/* <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Be The Future.</p>
                        <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Be An AI Amplified</p>
                        <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Software Engineer.</p> */}
            <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Be The Future.
            </p>
            <p className="text-xl sm:text-xl md:text-xl leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Be An AI Amplified Software Engineer.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center">
        <div className="faq-content px-0 py-0 sm:px-4 sm:py-4 max-w-4xl mx-8 justify-center">
          <h2 className="faq-content font-bold px-4 py-4 max-w-4xl w-full mx-auto">
            FAQs
          </h2>
          <p className="text-left text-black mb-3 ml-4 leading-snug">
            Whether you are a student eager to shape the future of technology or
            an institution committed to building a world-class engineering
            program, Agivant invites you to be a part of our AI-powered journey.
            Together, let's redefine the boundaries of software engineering and
            create a brighter future for all.
          </p>

          <div className="faq-container ">
            <div className="flex justify-center  space-x-2">
              <button
                className={`toggle-btn py-2 rounded-lg bg-white ${
                  activeSection === "students"
                    ? "border-gray-300 border-x-2 border-t-2 mx-5 faq-container-selected"
                    : " "
                }`}
                onClick={() => setActiveSection("students")}
              >
                Students
              </button>
              <button
                className={`toggle-btn py-2 rounded-lg bg-white ${
                  activeSection === "colleges"
                    ? "border-gray-300 border-x-2 border-t-2 mx-5 faq-container-selected"
                    : " "
                }`}
                onClick={() => setActiveSection("colleges")}
              >
                Institutes
              </button>
            </div>
            <hr className="w-full border-t-2 border-gray-300 mb-4" />

            <div className="accordion items-center mb-6">
              {faqs[activeSection].map((faq, index) => (
                <div key={index} className="accordion-item sm:justify-between">
                  <div
                    className="accordion-header cursor-pointer w-full flex justify-between items-center border-1 border-gray-300 bg-white  hover:bg-gray-100 "
                    onClick={() => toggleAccordion(index)}
                  >
                    <h4 className="md:text-lg text-gray-700 sm:text-sm mr-3 flex-1">
                      {faq.question}
                    </h4>
                    <span className="relative flex items-center justify-center w-6 h-6 bg-gray-200 rounded-full ">
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text- black">
                        <FaPlus size="100%" />
                      </div>
                    </span>
                  </div>
                  {expanded === index && (
                    <div className="accordion-body bg-gray-50  relative border-1 border-gray-300 ">
                      <p className="text-gray-600 text-sm font-normal m-2 text-left ">
                        {faq.answer}
                      </p>
                      <span
                        className="absolute top-2 right-2 m-2 flex items-center justify-center w-6 h-6 bg-gray-200 rounded-full cursor-pointer"
                        onClick={() => toggleAccordion(index)}
                      >
                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text- black">
                          <RxCross1 size="100%" />
                        </div>
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQ;
